/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import RowStyles from './RowStyles.js';
import { injectTestId } from '@cvent/nucleus-test-automation';

export default class Row extends React.Component {
  static propTypes = {
    /** The z-index of the Row. Corresponds to css z-index */
    zIndex: PropTypes.number,
    /** Children of Rows may ONLY be Cols */
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.arrayOf(PropTypes.element)
    ]),

    /** flexGrow is useful for flexible vertical layouts. */
    flexGrow: PropTypes.number,

    /** determines horizontal alignment */
    justifyContent: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),

    /** Units are pixels. Negative margins may be useful for aligning a Layout with other page content.
     * If margin is provided as a single number, the Row will have that margin on right and left. If margin is provided as an object, follow the PropType shape given. Omit values that should be inherited from smaller sizes. If `isRtl` prop is false, `marginStart` will evaluate to `marginLeft`, the opposite is true for RTL */
    margin: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.shape({
        top: PropTypes.number,
        end: PropTypes.number,
        bottom: PropTypes.number,
        start: PropTypes.number
      })
    ]),

    /** Variable-minWidth: numbers <= 1 are interpreted as percentages. ex: 1/2 and .5 evaluate to one-half the width of the Col's parent Row.
     * Fixed-minWidth: numbers > 1 are interpreted as pixels. ex: 100 evaluates to '100px'.
     * Standard CSS values provided as strings will be applied verbatim. ex: `calc(100% - 60px)`*/
    minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Text direction right-to-left */
    isRtl: PropTypes.bool
  };

  static defaultProps = {
    minHeight: 0,
    justifyContent: 'flex-start'
  };

  render() {
    const {
      children,
      minHeight,
      flexGrow,
      justifyContent,
      isRtl,
      margin,
      className,
      testID,
      zIndex,
      ...restProps
    } = this.props;
    const styles = new RowStyles({
      zIndex,
      minHeight,
      justifyContent: justifyContent.toLowerCase(),
      flexGrow,
      isRtl,
      margin
    });

    return (
      <div
        {...restProps}
        {...injectTestId(testID)}
        css={styles}
        data-layout="row"
      >
        {children}
      </div>
    );
  }
}
